"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Source;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _uuid = require("uuid");
const _config = require("~/interface/config");
const _models = require("~/models");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _catchError = require("~/helpers/catchError");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _modelUtils = require("~/utils/modelUtils");
const _jobsredis = require("~/modules/jobs/redis/jobs-redis");
const _Jobs = require("~/interface/Jobs");
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _utils = require("~/utils");
const _nccachedecorator = require("~/decorators/nc-cache.decorator");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let Source = class Source {
    static castType(source) {
        return source && new Source(source);
    }
    static encryptConfigIfRequired(obj) {
        obj.config = (0, _utils.encryptPropIfRequired)({
            data: obj
        });
        obj.is_encrypted = (0, _utils.isEncryptionRequired)();
    }
    static async createBase(context, source, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(source, [
            'id',
            'alias',
            'config',
            'type',
            'is_meta',
            'is_local',
            'inflection_column',
            'inflection_table',
            'order',
            'enabled',
            'meta',
            'is_schema_readonly',
            'is_data_readonly',
            'fk_integration_id',
            'is_encrypted'
        ]);
        this.encryptConfigIfRequired(insertObj);
        if ('meta' in insertObj) {
            insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        }
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.SOURCES, {
            base_id: source.baseId
        });
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.SOURCES, insertObj);
        const returnBase = await this.get(context, id, false, ncMeta);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.SOURCE, [
            source.baseId
        ], `${_globals.CacheScope.SOURCE}:${id}`);
        return returnBase;
    }
    static async update(context, sourceId, source, ncMeta = _Noco.default.ncMeta) {
        const oldSource = await this.get(context, sourceId, false, ncMeta);
        if (!oldSource) _catchError.NcError.sourceNotFound(sourceId);
        const updateObj = (0, _extractProps.extractProps)(source, [
            'alias',
            'config',
            'type',
            'is_meta',
            'is_local',
            'inflection_column',
            'inflection_table',
            'order',
            'enabled',
            'meta',
            'deleted',
            'fk_sql_executor_id',
            'is_schema_readonly',
            'is_data_readonly',
            'fk_integration_id',
            'is_encrypted'
        ]);
        if (updateObj.config) {
            this.encryptConfigIfRequired(updateObj);
        }
        // type property is undefined even if not provided
        if (!updateObj.type) {
            updateObj.type = oldSource.type;
        }
        if ('meta' in updateObj) {
            updateObj.meta = (0, _modelUtils.stringifyMetaProp)(updateObj);
        }
        // if order is missing (possible in old versions), get next order
        if (!oldSource.order && !updateObj.order) {
            updateObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.SOURCES, {
                base_id: oldSource.base_id
            });
            if (updateObj.order <= 1 && !oldSource.isMeta()) {
                updateObj.order = 2;
            }
        }
        // keep order 1 for default source
        if (oldSource.isMeta()) {
            updateObj.order = 1;
        }
        // keep order 1 for default source
        if (!oldSource.isMeta()) {
            if (updateObj.order <= 1) {
                _catchError.NcError.badRequest('Cannot change order to 1 or less');
            }
            // if order is 1 for non-default source, move it to last
            if (oldSource.order <= 1 && !updateObj.order) {
                updateObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.SOURCES, {
                    base_id: oldSource.base_id
                });
            }
        }
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.SOURCES, (0, _modelUtils.prepareForDb)(updateObj), oldSource.id);
        await _NocoCache.default.update(context, `${_globals.CacheScope.SOURCE}:${sourceId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        // trigger cache clear and don't wait
        this.updateRelatedCaches(context, sourceId, ncMeta).catch((e)=>{
            console.error(e);
        });
        if (_jobsredis.JobsRedis.available) {
            await _jobsredis.JobsRedis.emitWorkerCommand(_Jobs.InstanceCommands.RELEASE, sourceId);
            await _jobsredis.JobsRedis.emitPrimaryCommand(_Jobs.InstanceCommands.RELEASE, sourceId);
        }
        return await this.get(context, oldSource.id, false, ncMeta);
    }
    static async list(context, args, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.SOURCE, [
            args.baseId
        ]);
        let { list: sourceDataList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !sourceDataList.length) {
            const qb = ncMeta.knex(_globals.MetaTable.SOURCES).select(`${_globals.MetaTable.SOURCES}.*`).where(`${_globals.MetaTable.SOURCES}.base_id`, context.base_id);
            if (!args.includeDeleted) {
                qb.where((whereQb)=>{
                    whereQb.where(`${_globals.MetaTable.SOURCES}.deleted`, false).orWhereNull(`${_globals.MetaTable.SOURCES}.deleted`);
                });
            }
            qb.orderBy(`${_globals.MetaTable.SOURCES}.order`, 'asc');
            this.extendQb(qb, context);
            sourceDataList = await qb;
            // parse JSON metadata
            for (const source of sourceDataList){
                source.meta = (0, _modelUtils.parseMetaProp)(source, 'meta');
            }
            await _NocoCache.default.setList(context, _globals.CacheScope.SOURCE, [
                args.baseId
            ], sourceDataList);
        }
        sourceDataList.sort((a, b)=>{
            var _ref, _ref1;
            return ((_ref = a == null ? void 0 : a.order) != null ? _ref : Infinity) - ((_ref1 = b == null ? void 0 : b.order) != null ? _ref1 : Infinity);
        });
        return sourceDataList == null ? void 0 : sourceDataList.map((sourceData)=>{
            return this.castType(sourceData);
        });
    }
    static async get(context, id, force = false, ncMeta = _Noco.default.ncMeta) {
        let sourceData = id && await _NocoCache.default.get(context, `${_globals.CacheScope.SOURCE}:${id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!sourceData) {
            const qb = ncMeta.knex(_globals.MetaTable.SOURCES).select(`${_globals.MetaTable.SOURCES}.*`).where(`${_globals.MetaTable.SOURCES}.id`, id).where(`${_globals.MetaTable.SOURCES}.base_id`, context.base_id);
            this.extendQb(qb, context);
            if (!force) {
                qb.where((whereQb)=>{
                    whereQb.where(`${_globals.MetaTable.SOURCES}.deleted`, false).orWhereNull(`${_globals.MetaTable.SOURCES}.deleted`);
                });
            }
            sourceData = await qb.first();
            if (sourceData) {
                sourceData.meta = (0, _modelUtils.parseMetaProp)(sourceData, 'meta');
            }
            await _NocoCache.default.set(context, `${_globals.CacheScope.SOURCE}:${id}`, sourceData);
        }
        return this.castType(sourceData);
    }
    async getConnectionConfig() {
        if (this.is_meta || this.is_local) {
            const metaConfig = await _NcConnectionMgrv2.default.getDataConfig();
            const config = _extends({}, metaConfig);
            if (config.client === 'sqlite3') {
                config.connection = metaConfig;
            }
            return config;
        }
        const config = this.getConfig();
        // todo: update sql-client args
        if ((config == null ? void 0 : config.client) === 'sqlite3') {
            var _config_connection;
            config.connection.filename = config.connection.filename || ((_config_connection = config.connection) == null ? void 0 : _config_connection.connection.filename);
        }
        return config;
    }
    getConfig(skipIntegrationConfig = false) {
        var _mergedConfig_searchPath;
        if (this.is_meta) {
            var _Noco_getConfig_meta, _Noco_getConfig;
            const metaConfig = (_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : (_Noco_getConfig_meta = _Noco_getConfig.meta) == null ? void 0 : _Noco_getConfig_meta.db;
            const config = _extends({}, metaConfig);
            if (config.client === 'sqlite3') {
                config.connection = metaConfig;
            }
            return config;
        }
        const config = (0, _utils.decryptPropIfRequired)({
            data: this
        });
        if (skipIntegrationConfig) {
            return config;
        }
        if (!this.integration_config) {
            return config;
        }
        const integrationConfig = (0, _utils.decryptPropIfRequired)({
            data: this,
            prop: 'integration_config'
        });
        // merge integration config with source config
        // override integration config with source config if exists
        // only override database and searchPath
        let mergedConfig = (0, _utils.deepMerge)(integrationConfig, (0, _utils.partialExtract)(config || {}, [
            [
                'connection',
                'database'
            ],
            [
                'searchPath'
            ]
        ]));
        // if searchPath is not array/string or if an empty array, remove it
        if (!Array.isArray(mergedConfig.searchPath) && typeof mergedConfig.searchPath !== 'string' || !((_mergedConfig_searchPath = mergedConfig.searchPath) == null ? void 0 : _mergedConfig_searchPath.length)) {
            mergedConfig = _extends({}, mergedConfig, {
                searchPath: undefined
            });
        }
        return mergedConfig;
    }
    getSourceConfig() {
        return this.getConfig(true);
    }
    getProject(context, ncMeta = _Noco.default.ncMeta) {
        return _models.Base.get(context, this.base_id, ncMeta);
    }
    async sourceCleanup(_ncMeta = _Noco.default.ncMeta) {
        await _NcConnectionMgrv2.default.deleteAwait(this);
        if (_jobsredis.JobsRedis.available) {
            await _jobsredis.JobsRedis.emitWorkerCommand(_Jobs.InstanceCommands.RELEASE, this.id);
            await _jobsredis.JobsRedis.emitPrimaryCommand(_Jobs.InstanceCommands.RELEASE, this.id);
        }
    }
    async delete(context, ncMeta = _Noco.default.ncMeta, { force } = {}) {
        const sources = await Source.list(context, {
            baseId: this.base_id
        }, ncMeta);
        if ((sources[0].id === this.id || this.isMeta()) && !force) {
            _catchError.NcError.badRequest('Cannot delete first source');
        }
        const models = await _models.Model.list(context, {
            source_id: this.id,
            base_id: this.base_id
        }, ncMeta);
        const relColumns = [];
        const relRank = {
            [_nocodbsdk.UITypes.Lookup]: 1,
            [_nocodbsdk.UITypes.Rollup]: 2,
            [_nocodbsdk.UITypes.ForeignKey]: 3,
            [_nocodbsdk.UITypes.LinkToAnotherRecord]: 4
        };
        for (const model of models){
            for (const col of (await model.getColumns(context, ncMeta))){
                let colOptionTableName = null;
                let cacheScopeName = null;
                switch(col.uidt){
                    case _nocodbsdk.UITypes.Rollup:
                        colOptionTableName = _globals.MetaTable.COL_ROLLUP;
                        cacheScopeName = _globals.CacheScope.COL_ROLLUP;
                        break;
                    case _nocodbsdk.UITypes.Lookup:
                        colOptionTableName = _globals.MetaTable.COL_LOOKUP;
                        cacheScopeName = _globals.CacheScope.COL_LOOKUP;
                        break;
                    case _nocodbsdk.UITypes.ForeignKey:
                    case _nocodbsdk.UITypes.LinkToAnotherRecord:
                        colOptionTableName = _globals.MetaTable.COL_RELATIONS;
                        cacheScopeName = _globals.CacheScope.COL_RELATION;
                        break;
                }
                if (colOptionTableName && cacheScopeName) {
                    relColumns.push({
                        col,
                        colOptionTableName,
                        cacheScopeName
                    });
                }
            }
        }
        relColumns.sort((a, b)=>{
            return relRank[a.col.uidt] - relRank[b.col.uidt];
        });
        for (const relCol of relColumns){
            await ncMeta.metaDelete(context.workspace_id, context.base_id, relCol.colOptionTableName, {
                fk_column_id: relCol.col.id
            });
            await _NocoCache.default.deepDel(context, `${relCol.cacheScopeName}:${relCol.col.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        }
        for (const model of models){
            await model.delete(context, ncMeta, true);
        }
        const syncSources = await _models.SyncSource.list(context, this.base_id, this.id, ncMeta);
        for (const syncSource of syncSources){
            await _models.SyncSource.delete(context, syncSource.id, ncMeta);
        }
        await this.sourceCleanup(ncMeta);
        const res = await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.SOURCES, this.id);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.SOURCE}:${this.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        return res;
    }
    async softDelete(context, ncMeta = _Noco.default.ncMeta, { force } = {}) {
        const sources = await Source.list(context, {
            baseId: this.base_id
        }, ncMeta);
        if ((sources[0].id === this.id || this.isMeta()) && !force) {
            _catchError.NcError.badRequest('Cannot delete first base');
        }
        await Source.update(context, this.id, {
            deleted: true
        }, ncMeta);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.SOURCE}:${this.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
    }
    async getModels(context, ncMeta = _Noco.default.ncMeta) {
        return await _models.Model.list(context, {
            base_id: this.base_id,
            source_id: this.id
        }, ncMeta);
    }
    async shareErd(context, ncMeta = _Noco.default.ncMeta) {
        if (!this.erd_uuid) {
            const uuid = (0, _uuid.v4)();
            this.erd_uuid = uuid;
            // set meta
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.SOURCES, {
                erd_uuid: this.erd_uuid
            }, this.id);
            await _NocoCache.default.update(context, `${_globals.CacheScope.SOURCE}:${this.id}`, {
                erd_uuid: this.erd_uuid
            });
        }
        return this;
    }
    async disableShareErd(context, ncMeta = _Noco.default.ncMeta) {
        if (this.erd_uuid) {
            this.erd_uuid = null;
            // set meta
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.SOURCES, {
                erd_uuid: this.erd_uuid
            }, this.id);
            await _NocoCache.default.update(context, `${_globals.CacheScope.SOURCE}:${this.id}`, {
                erd_uuid: this.erd_uuid
            });
        }
        return this;
    }
    isMeta(_only = false, _mode = 0) {
        if (_only) {
            if (_mode === 0) {
                return this.is_meta;
            }
            return this.is_local;
        } else {
            return this.is_meta || this.is_local;
        }
    }
    static extendQb(qb, _context) {
        qb.select(`${_globals.MetaTable.INTEGRATIONS}.config as integration_config`, `${_globals.MetaTable.INTEGRATIONS}.title as integration_title`).leftJoin(_globals.MetaTable.INTEGRATIONS, `${_globals.MetaTable.SOURCES}.fk_integration_id`, `${_globals.MetaTable.INTEGRATIONS}.id`);
    }
    static async updateRelatedCaches(context, sourceId, ncMeta = _Noco.default.ncMeta) {
        // get models
        const models = await _models.Model.list(context, {
            source_id: sourceId,
            base_id: context.base_id
        }, ncMeta);
        // clear single query caches for models
        for (const model of models){
            await _View.default.clearSingleQueryCache(context, model.id, null, ncMeta);
        }
    }
    constructor(source){
        this.upgraderQueries = [];
        Object.assign(this, source);
    }
};
_ts_decorate([
    (0, _nccachedecorator.NcCache)({
        key: (args)=>args[1]
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], Source, "get", null);
